import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { API_COMMON_GAME_SETTING } from "../../../../utils/api/ApiConstant";
import { getAxios, putAxios } from "../../../Services/commonService";
import { Button, Input, Loading } from "../../";
import { cleanUpValue } from "../../../helper/common";
import Icon from "../../../../assets/icons/Icon";

const CupSettings = () => {
  const [finalData, setFinalData] = useState([]);
  const { isLoading, data: CupSettingsData } = useQuery({
    queryKey: ["CupSettingsData"],
    queryFn: async () =>
      await getAxios(`${API_COMMON_GAME_SETTING}/cup`, {
        page: 1,
        limit: 10,
      }),
    staleTime: 300000,
  });

  useEffect(() => {
    if (CupSettingsData?.docs) {
      setFinalData(CupSettingsData?.docs);
    }
  }, [CupSettingsData]);

  const handleChange = (e, cup) => {
    const { name, value } = e.target;
    const updatedData = finalData.map((row) =>
      row?._id === cup?._id ? { ...row, [name]: value } : row
    );
    setFinalData(updatedData);
  };

  const handleEdit = async (isAllUpdate, rowData) => {
    const url = isAllUpdate
      ? `${API_COMMON_GAME_SETTING}/updateAllMarket/cup`
      : `${API_COMMON_GAME_SETTING}/cup/${rowData?._id}`;
    await putAxios(url, rowData);
  };

  return (
    <div className="table-responsive">
      <table
       
        className="report-card-box"
      >
        <thead className="table-light">
          <tr>
            <th>No.</th>
            <th className="text-start">sports</th>
            <th className="text-start">volume</th>
            <th className="text-start">min stack</th>
            <th className="text-start">max stack</th>
            <th className="text-start">max profit</th>
            <th className="text-start">max loss</th>
            <th className="text-start">bet delay</th>
            <th className="text-start">min odds</th>
            <th className="text-start">max odds</th>
            <th className="text-start">commission</th>
            <th className="text-start">pre in play profit</th>
            <th className="text-start">pre in play stake</th>
            <th className="text-start">action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="14" style={{ textAlign: "center" }}>
                <Loading />
              </td>
            </tr>
          ) : (
            finalData &&
            finalData.length > 0 &&
            finalData.map((cup, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td className="text-start">{cleanUpValue(cup?.sport?.name)}</td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="volume"
                    id="volume"
                    type="number"
                    value={cup?.volume}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="minStack"
                    id="minStack"
                    type="number"
                    value={cup?.minStack}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxStack"
                    id="maxStack"
                    type="number"
                    value={cup?.maxStack}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxProfit"
                    id="maxProfit"
                    type="number"
                    value={cup?.maxProfit}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxLoss"
                    id="maxLoss"
                    type="number"
                    value={cup?.maxLoss}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="betDelay"
                    id="betDelay"
                    type="number"
                    value={cup?.betDelay}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="minOdds"
                    id="minOdds"
                    type="number"
                    value={cup?.minOdds}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxOdds"
                    id="maxOdds"
                    type="number"
                    value={cup?.maxOdds}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="commission"
                    id="commission"
                    type="number"
                    value={cup?.commission}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="preInPlayProfit"
                    id="preInPlayProfit"
                    type="number"
                    value={cup?.preInPlayProfit}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="preInPlayStack"
                    id="preInPlayStack"
                    type="number"
                    value={cup?.preInPlayStack}
                    onChange={(e) => handleChange(e, cup)}
                  />
                </td>
                <td className="text-start">
                  <div className="action_icon_box">
                    <Icon
                      name="FaEdit"
                      className=" icon_button"
                      cursorPointer={true}
                      onClick={() => handleEdit(false, cup)}
                    />
                    <Button
                      className="btn_main  "
                      onClick={() => handleEdit(true, cup)}
                    >
                      U-A
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CupSettings;
